module.exports = __webpack_public_path__ + "img/397.9acf4f7f.jpg";